
export default {
  /* tslint:disable */
  render () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"ae-headroom",class:[
    'relative h-full overflow-y-auto w-full transition-padding-top duration-300',
    _vm.containerClass
  ],style:({ paddingTop: _vm.contentPadding })},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"},on:{"enter":_vm.enter,"leave":_vm.leave}},[(_vm.isVisible)?_c('div',{ref:"topBar",class:[
        _vm.topBarClass,
        'z-10',
        _vm.mode === 'sticky' ? 'sticky top-0' : 'fixed left-0 right-0 top-0',
        ( _obj = {}, _obj[_vm.overlayClass] = _vm.isScrolled, _obj )
      ]},[_vm._t("top")],2):_vm._e()]),_vm._v(" "),_c('div',{class:_vm.contentClass},[_vm._t("default")],2)],1)},
  staticRenderFns: [],
  /* tslint:enable */
  
  props: {
    mode: {
      type: String,
      default: 'sticky',
      validator: (val) => ['sticky', 'headroom'].includes(val)
    },
    containerClass: { type: String, default: '' },
    topBarClass: { type: String, default: '' },
    contentClass: { type: String, default: '' },
    transitionName: { type: String, default: 'slide' },
    overlayClass: { type: String, default: '' }
  },
  data() {
    return {
      isVisible: true,
      isScrolled: false,
      lastScrollY: 0,
      threshold: 10,
      topHeight: 0,
      contentPadding: '0px'
    };
  },
  watch: {
    isVisible(newVal) {
      this.updatePadding();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateHeightAndPadding();
      this.updateScrollPosition();
    });
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (this.mode === 'headroom' && isMobile) {
      this.$refs.container.addEventListener('scroll', this.handleScroll);
    } else if (this.mode === 'headroom') {
      this.isVisible = true;
    }
    this.$refs.container.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.$refs.container.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    updateScrollPosition() {
      const scrollPosition = this.$refs.container.scrollTop;
      this.isScrolled = scrollPosition > 0;
      this.lastScrollY = scrollPosition;
    },
    handleScroll() {
      const currentScrollY = this.$refs.container.scrollTop;
      this.isScrolled = currentScrollY > 0;
      const delta = currentScrollY - this.lastScrollY;
      if (this.mode === 'headroom' && window.matchMedia('(max-width: 767px)').matches) {
        if (delta > this.threshold && currentScrollY > 0) {
          this.isVisible = false;
        } else if (delta < -this.threshold || currentScrollY <= 0) {
          this.isVisible = true;
        }
      }
      this.lastScrollY = currentScrollY;
    },
    updateHeightAndPadding() {
      if (this.$refs.topBar) {
        this.topHeight = this.$refs.topBar.offsetHeight;
      }
      this.updatePadding();
    },
    updatePadding() {
      if (this.mode === 'headroom') {
        this.contentPadding = this.isVisible ? `${this.topHeight}px` : '0px';
      } else {
        this.contentPadding = '0px';
      }
    },
    handleResize() {
      this.$nextTick(() => {
        this.updateHeightAndPadding();
        this.updateScrollPosition();
      });
    },
    enter(el, done) { done(); },
    leave(el, done) { done(); }
  }
};
